function Icon({ className }: { className?: string }) {
  return (
    <svg
      style={{ fill: 'currentColor' }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="24px"
      height="24px"
      className={className}
    >
      <path d="M25,3C12.85,3,3,12.85,3,25c0,11.03,8.125,20.137,18.712,21.728V30.831h-5.443v-5.783h5.443v-3.848 c0-6.371,3.104-9.168,8.399-9.168c2.536,0,3.877,0.188,4.512,0.274v5.048h-3.612c-2.248,0-3.033,2.131-3.033,4.533v3.161h6.588 l-0.894,5.783h-5.694v15.944C38.716,45.318,47,36.137,47,25C47,12.85,37.15,3,25,3z" />
    </svg>
  );
}

function Facebook() {
  return (
    <a
      href="https://facebook.com/zijmespolecne"
      target="_blank"
      className="shadow-lg shadow-blue-100 rounded-lg border border-blue-100 bg-white px-3 py-6 mx-auto max-w-2xl flex flex-col items-center text-center my-16"
      rel="noreferrer"
    >
      <Icon className="text-blue-500 w-8 h-8 mb-4" />
      <h3 className="m-0 text-lg text-3xl leading-4 font-extrabold tracking-tight text-blue-900 mb-1">
        Sledujte naši aktivitu
      </h3>
      <p className="mb-3 text-gray-500">Vždy nejaktuálnější informace naleznete na naší Facebookové stránce.</p>
      <button
        type="button"
        className="inline-flex pointer-events-none items-center px-2.5 py-1.5 border border-transparent text-sm font-medium rounded-full text-blue-900 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        Přejít na Facebook
      </button>
    </a>
  );
}

export default Facebook;
